import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 조회된 항목이 없을 때 통일된 빈 상태 안내 메시지 컴포넌트
 */
const EmptyMessage = ({ text, className = '', variant, as: Wrapper = 'div' }) => {
  const { t } = useTranslation();
  const displayText = text ?? t('components.common.noData');

  return (
    <>
      <Wrapper className={`widget-empty-wrap ${variant === 'inline' ? 'widget-empty-wrap--inline' : ''} ${className}`.trim()}>
        <span className="widget-empty-icon" aria-hidden="true">!</span>
        <p className="widget-empty-text">{displayText}</p>
      </Wrapper>
      <style>{`
      .widget-empty-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.875rem;
        text-align: center;
        padding: 3rem 1.5rem;
        margin: 0;
        min-height: 50vh;
        background: linear-gradient(135deg, #eff6ff 0%, #ffffff 50%, #faf5ff 100%);
        border-top: 1px solid #e8e7e8;
        border-bottom: 1px solid #e8e7e8;
      }
      .widget-empty-wrap.widget-empty-wrap--inline {
        min-height: 0;
        padding: 2rem 1rem;
        background: transparent;
        border: none;
      }
      .widget-empty-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        border: 2px solid #898989;
        background: transparent;
        color: #898989;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
      }
      .widget-empty-text {
        font-size: 1rem;
        color: #898989;
        margin: 0;
        font-weight: 400;
      }
    `}</style>
    </>
  );
};

export default EmptyMessage;
